export default __webpack_public_path__ + "static/media/ne-logo.751bf8e4.png";